import React from 'react';
import { hot } from 'react-hot-loader';
import Newsletter from '../../Footer/Newsletter';
import Breadcrumbs from '../../Category/Breadcrumbs';

const Placeholder = ({ content }) => {
	if (content?.placeholder === 'newsletter') {
		return <Newsletter />;
	}
	if (content?.placeholder === 'breadcrumbs') {
		return <Breadcrumbs placeholder />;
	}

	return null;
};

export default hot(module)(Placeholder);
